<template>
  <div>
    <v-layout row wrap py-2>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon color="secondary">apps</v-icon>
            <span>&ensp;</span>
            <h3>{{ $t('title.app') }}</h3>
            <v-spacer></v-spacer>
            <mode-selection v-on:onSwitchMode="onSwitchMode"></mode-selection>
          </v-card-title>
          <v-card-text>
            <v-form v-model="valid">
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>ID</strong>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="items.id"
                    disabled
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong><span class="red--text">*</span>{{ $t('items.name') }}</strong>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    ref="name"
                    autofocus
                    v-model="items.name"
                    :rules="[
                      v => !!v || $t('rules.required'),
                      // v => /^[a-zA-Z0-9-_]+$/.test(v) || $t('rules.unusable'),
                      v => v && v.length <= 45 || $t('rules.max45c')
                    ]"
                    counter="45"
                    :disabled="mode"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong><span class="red--text">*</span>{{ $t('items.plan') }}</strong>
                </v-flex>
                <v-flex xs6 v-if="user.role === 'Manager'">
                  <v-btn-toggle mandatory v-model="items.plan">
                    <v-btn
                      v-for="(item, i) in plan"
                      :key="i"
                      :value="item.value"
                      :disabled="item.disabled || mode"
                      color="primary"
                      class="white--text"
                    >
                      <span>{{ item.text }}</span>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                  <p class="caption grey--text pt-2 mb-0">{{ $t('discriptions.plan') }}</p>
                </v-flex>
              </v-layout>
              <v-layout row pb-3>
                <v-flex xs6 offset-xs2>
                  <plan-descriptions :active="items.plan"></plan-descriptions>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>SDK SECRET</strong>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    v-model="secret.sdk"
                    disabled
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    small
                    :data-clipboard-text="secret.sdk"
                    slot="activator"
                    class="clipboard"
                  >
                    <v-icon color="secondary">content_copy</v-icon>
                  </v-btn>
                  <span>{{ $t('common.copy') }}</span>
                </v-tooltip>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>API SECRET</strong>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    v-model="secret.api"
                    disabled
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    small
                    :data-clipboard-text="secret.api"
                    slot="activator"
                    class="clipboard"
                  >
                    <v-icon color="secondary">content_copy</v-icon>
                  </v-btn>
                  <span>{{ $t('common.copy') }}</span>
                </v-tooltip>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>BUNDLE ID ( iOS )</strong>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    prepend-icon="phone_iphone"
                    placeholder="jp.example.app.ios"
                    v-model="bundle_id.ios"
                    :rules="[
                      v => !v || /^[a-zA-Z0-9-_.]+$/.test(v) || $t('rules.unusable'),
                      v => !v || v.length <= 45 || $t('rules.max45c')
                    ]"
                    counter="45"
                    :disabled="mode"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>BUNDLE ID ( Android )</strong>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    prepend-icon="phone_android"
                    placeholder="jp.example.app.android"
                    v-model="bundle_id.android"
                    :rules="[
                      v => !v || /^[a-zA-Z0-9-_.]+$/.test(v) || $t('rules.unusable'),
                      v => !v || v.length <= 45 || $t('rules.max45c')
                    ]"
                    counter="45"
                    :disabled="mode"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>BUNDLE ID</strong>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    v-model="bundle_id.bundle_id"
                    :disabled="mode"
                    class="pt-0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong><span class="red--text">*</span>{{ $t('items.timer') }}</strong>
                </v-flex>
                <v-flex xs3>
                  <v-menu
                    ref="menu01"
                    :close-on-content-click="false"
                    v-model="menu01"
                    :nudge-right="40"
                    :return-value.sync="items.timer_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="items.timer_date"
                      prepend-icon="event"
                      :rules="[
                        v => !!v || $t('rules.required'),
                      ]"
                      readonly
                      :disabled="mode"
                      class="pt-0"
                    ></v-text-field>
                    <v-date-picker v-model="items.timer_date">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu01 = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu01.save(items.timer_date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3>
                  <v-menu
                    ref="menu02"
                    :close-on-content-click="false"
                    v-model="menu02"
                    :nudge-right="40"
                    :return-value.sync="items.timer_time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="items.timer_time"
                      prepend-icon="access_time"
                      :rules="[
                        v => !!v || $t('rules.required'),
                      ]"
                      readonly
                      :disabled="mode"
                      class="pt-0"
                    ></v-text-field>
                    <v-time-picker v-model="items.timer_time" @change="$refs.menu02.save(items.timer_time)"></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.settings') }}</strong>
                </v-flex>
                <v-flex xs6>
                  <v-layout row>
                    <v-flex xs12 class="grey--text pt-3">
                      <strong><span class="red--text">*</span>{{ $t('items.log_interval') }} ( BEACON LOGS / EVENT LOGS / REGION LOGS )</strong>
                      <span>&ensp;</span>
                      <span class="caption">*{{ $t('discriptions.log_interval') }}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="bluetooth"
                        v-model="settings.interval.beacon_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1 || $t('rules.min1n'),
                          v => v <= 3600 || $t('rules.max3600n')
                        ]"
                        min="1"
                        max="3600"
                        :suffix="$t('suffix.second')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="event"
                        v-model="settings.interval.event_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1 || $t('rules.min1n'),
                          v => v <= 3600 || $t('rules.max3600n')
                        ]"
                        min="1"
                        max="3600"
                        :suffix="$t('suffix.second')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="place"
                        v-model="settings.interval.region_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1 || $t('rules.min1n'),
                          v => v <= 3600 || $t('rules.max3600n')
                        ]"
                        min="1"
                        max="3600"
                        :suffix="$t('suffix.second')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12 class="grey--text pt-3">
                      <strong><span class="red--text">*</span>{{ $t('items.buffer') }} ( BEACON LOGS / EVENT LOGS / REGION LOGS )</strong>
                      <span>&ensp;</span>
                      <span class="caption">*{{ $t('discriptions.buffer') }}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="bluetooth"
                        v-model="settings.buffer.beacon_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1000 || $t('rules.min1000n'),
                          v => v <= 100000 || $t('rules.max100000n')
                        ]"
                        min="1000"
                        max="100000"
                        :suffix="$t('suffix.number')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="event"
                        v-model="settings.buffer.event_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1000 || $t('rules.min1000n'),
                          v => v <= 100000 || $t('rules.max100000n')
                        ]"
                        min="1000"
                        max="100000"
                        :suffix="$t('suffix.number')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="place"
                        v-model="settings.buffer.region_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1000 || $t('rules.min1000n'),
                          v => v <= 100000 || $t('rules.max100000n')
                        ]"
                        min="1000"
                        max="100000"
                        :suffix="$t('suffix.number')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12 class="grey--text pt-3">
                      <strong><span class="red--text">*</span>{{ $t('items.config_postion') }} ( {{ $t('items.log_interval') }} / {{ $t('items.buffer') }} / {{ $t('items.period') }} )</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="place"
                        v-model="settings.interval.position_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1 || $t('rules.min1n'),
                          v => v <= 3600 || $t('rules.max3600n')
                        ]"
                        min="1"
                        max="3600"
                        :suffix="$t('suffix.second')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="place"
                        v-model="settings.buffer.position_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1000 || $t('rules.min1000n'),
                          v => v <= 100000 || $t('rules.max100000n')
                        ]"
                        min="1000"
                        max="100000"
                        :suffix="$t('suffix.number')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        prepend-icon="place"
                        v-model="settings.position_log_period"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => v >= 1 || $t('rules.min1n'),
                          v => v <= 60 || $t('rules.max60n'),
                        ]"
                        min="1"
                        :suffix="$t('suffix.second')"
                        type="number"
                        :disabled="mode"
                        class="pt-0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12 class="grey--text pt-3">
                      <strong><span class="red--text">*</span>{{ $t('items.config_device') }} ( {{ $t('items.generation_type') }} / {{ $t('items.generation_interval') }})</strong>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs8>
                      <v-radio-group
                        v-model="settings.device_log_generation"
                        :rules="[v => !!v || $t('rules.required')]"
                        row
                        :disabled="mode"
                        class="radio-group-full-width"
                      >
                        <v-radio
                          :label="$t('suffix.device_log_type.always')"
                          value="always"
                        ></v-radio>

                        <v-radio
                          :label="$t('suffix.device_log_type.daily')"
                          value="daily"
                        ></v-radio>

                        <v-radio
                          :label="$t('suffix.device_log_type.duration')"
                          value="duration"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs4 class="d-flex align-end">
                      <v-text-field
                        prepend-icon="place"
                        v-model="settings.interval.device_logs"
                        :rules="[
                          v => !!v || $t('rules.required'),
                          v => !v || v >= 1 || $t('rules.min1n'),
                          v => !v || v <= 14400 || $t('rules.max14400n'),
                        ]"
                        min="1"
                        max="14400"
                        :suffix="$t('suffix.minute')"
                        type="number"
                        :disabled="mode || settings.device_log_generation !== 'duration'"
                        class="pt-0 device-logs-field"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.image') }}</strong>
                </v-flex>
                <v-flex xs6>
                  <div
                    @click.stop="onPickFile"
                    @dragover.prevent
                    @drop.prevent="onDropFile"
                    :class="[
                      'image-box',
                      mode ? 'disabled' : '',
                      error ? 'size' : ''
                    ]"
                  >
                    <span class="caption grey--text" v-if="!image">{{ $t('discriptions.image') }}</span>
                    <img :src="image" alt="" class="image small">
                    <br />
                    <v-btn outline small color="error" @click.stop="onRemoveFile" v-if="image && !mode">{{ $t('common.remove') }}</v-btn>
                    <input type="file" ref="file" accept="image/*" @change="onChangeFile">
                  </div>
                  <span class="caption error--text" v-if="error">{{ message }}</span>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text pt-3">
                  <strong>{{ $t('items.status') }}</strong>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox v-model="items.enabled" :disabled="mode"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text">
                  <strong>{{ $t('items.created') }}</strong>
                </v-flex>
                <v-flex xs6 class="grey--text">
                  {{ items.created | dateFormat }}
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs2 class="text-xs-right grey--text">
                  <strong>{{ $t('items.updated') }}</strong>
                </v-flex>
                <v-flex xs6 class="grey--text">
                  {{ items.updated | dateFormat }}
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn outline color="secondary" @click.stop="$router.go(-1)">{{ $t('common.back') }}</v-btn>
            <v-spacer></v-spacer>
            <app-delete-confirmation
              v-on:onDelete="onDelete"
              :loading="loading"
              v-if="user.role === 'Manager' && !mode"
            ></app-delete-confirmation>
            <save-confirmation
              v-on:onSave="onSave"
              :valid="valid"
              :loading="loading"
              v-if="!mode"
            ></save-confirmation>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import TimeFilter from "../../utils/filters/TimeFilter";
import ImageMethod from "../../utils/methods/ImageMethod";
import ClipboardMethod from "../../utils/methods/ClipboardMethod";
import ModeSelection from "../../components/ModeSelection";
import PlanDescriptions from "../../components/apps/PlanDescriptions";
import AppDeleteConfirmation from "../../components/dialogs/AppDeleteConfirmation";
import SaveConfirmation from "../../components/dialogs/SaveConfirmation";

export default {
  data() {
    return {
      mode: true,
      valid: false,
      loading: false,
      plan: [
        {
          icon: "directions_walk",
          value: "Startup",
          text: "startup",
          disabled: false
        },
        {
          icon: "directions_run",
          value: "Standard",
          text: "standard",
          disabled: false
        },
        {
          icon: "directions_bike",
          value: "Premium",
          text: "premium",
          disabled: false
        }
      ],
      menu01: false,
      menu02: false,
      items: {},
      // Objects
      secret: {},
      bundle_id: {},
      settings: {
        interval: {},
        buffer: {}
      }
    };
  },
  components: {
    ModeSelection,
    PlanDescriptions,
    AppDeleteConfirmation,
    SaveConfirmation
  },
  computed: {
    ...mapState(["user"])
  },
  mounted() {
    this.onFetch();
  },
  methods: {
    ...mapActions(["onNotify"]),
    onFetch() {
      axios.get(this.$route.path).then(response => {
        if (response.data.code === 200) {
          this.items = response.data.payload;
          // Objects
          this.secret = this.items.secret;
          this.bundle_id = this.items.bundle_id;
          this.settings = this.items.settings;
          this.image = this.items.image;

          switch (this.items.plan) {
            case "Standard":
              this.plan[0].disabled = true;
              break;
            case "Premium":
              this.plan[0].disabled = true;
              this.plan[1].disabled = true;
              break;
          }
        } else {
        }
      });
    },
    onSwitchMode(val) {
      this.mode = val;
      this.$nextTick(() => this.$refs["name"].focus());
    },
    onDelete() {
      this.loading = true;
      axios.delete(this.$route.path).then(response => {
        if (response.data.code === 200) {
          setTimeout(() => {
            this.loading = false;
            this.$router.go(-1);
            this.onNotify({
              type: "error",
              text: "Deleting Successfully!"
            });
          }, 1000);
        } else {
          this.loading = false;
          this.onNotify({
            type: "error",
            text: this.$t('rules.app_cant_delete')
          });
        }
      });
    },
    onSave() {
      this.loading = true;
      axios.put(this.$route.path, this.items).then(response => {
        if (response.data.code === 200) {
          setTimeout(() => {
            this.loading = false;
            this.$router.go(-1);
            this.onNotify({
              type: "success",
              text: this.$t('common.saved')
            });
          }, 1000);
        } else {
          setTimeout(() => {
            this.loading = false;
            let messages = response.data.payload;
            let text = "";
            Object.keys(messages).forEach(key => {
              text += `${messages[key]}<br>`;
            });
            this.onNotify({
              type: "error",
              text: text,
              multiLine: true
            });
          }, 1000);
        }
      });
    },
  },
  mixins: [TimeFilter, ImageMethod, ClipboardMethod]
};
</script>

<style scoped>
.radio-group-full-width >>> .v-input__control {
  width: 100%;
}

.radio-group-full-width >>> .v-input__control > .v-input__slot {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.radio-group-full-width >>> .v-radio {
  flex: 1;
  margin-right: 0 !important;
}

.device-logs-field.v-input--is-disabled >>> .v-text-field__suffix {
  color: rgba(0,0,0,0.38);
}
</style>
